export const DEFAULT_ID = '000000000000000000000000';

export const appEmails = {
  support: 'support@solsten.io',
  explore: 'support@solsten.io',
  navigator: 'navigator@solsten.io'
};

export const LOGIN_FORM_HIDDEN_DOMAINS = new Set(['dk']);
